



































































import { Component, Vue } from "vue-property-decorator";
import { jsonp } from "../tool/jsonp";

@Component
export default class search extends Vue {
  private c: string = ""; //联想词
  private dis: boolean = false; //联想词显示flag'
  private word: string = "";
  private i: number = 0; //计数器，计算正在选中的关键词
  private keyFlag: string = "-"; //前回操作的状态，联想词方向键用

  constructor() {
    super();
    // //初期化创建默认值
    // var i = localStorage.getItem("action");
    // if ("null" == i || undefined == i) {
    //   //TODO 默认搜索待定 用户选择？

    // }
    (window as any).callback = this.callback;
  }
  //提交form
  public submit(): void {
    let myForm: any = document.getElementById("search_form");
    //谷歌添加中文搜索设置
    if(this.$store.state.action.indexOf("google")!= -1){
    var newElement = document.createElement("input");
    newElement.setAttribute("type", "hidden");
    newElement.name = "lr";
    newElement.value = "lang_zh-CN";
    //alert(newElement.name);
    myForm.appendChild(newElement);
    var newwindow = document.createElement("input");
    newwindow.setAttribute("type", "hidden");
    newwindow.name = "newwindow";
    newwindow.value = "1";
    //alert(newElement.name);
    myForm.appendChild(newwindow);
    }
    setTimeout(function () {
      myForm.submit();
      myForm.removeChild(newElement);
      myForm.removeChild(newwindow);
    }, 10);
  }
  public callback(a: any): void {
    if (a.s != "") {
      this.dis = true;
      //初始化按键选择计数器
      // if (this.c != "") {
      //   this.$refs.list[this.i].style.background = "rgba(0, 0, 0, 0)"; //还原颜色
      // }
      //重置方向键初始值
      this.keyFlag = "-";
      this.i = 0;
      //设置联想词
      this.c = a.s;
    } else {
      this.dis = false;
    }
  }
  //方向键上
  public keyUp(): void {
    //还原颜色
    (this.$refs.list as any)[this.i].style.background = "rgba(0, 0, 0, 0)";

    //设置本次下标位置
    if (this.i == 0) {
      this.i = this.c.length - 1;
    } else {
      this.i--;
    }
    //this.flag = false; //禁止联想词刷新    TODO
    this.word = this.c[this.i]; //改变联想词为选中行
    (this.$refs.list as any)[this.i].style.background = "rgba(0, 0, 0, .08)"; //修改选中行样式
  }
  //方向键下
  public keyDown(): void {
    // 还原颜色
    (this.$refs.list as any)[this.i].style.background = "rgba(0, 0, 0, 0)";
    // }
    //设置本次下标 判断到列表最后一位返回0，以及首次操作默认0
    if (this.i == this.c.length - 1 || this.keyFlag == "-") {
      this.keyFlag = "";
      this.i = 0;
    } else {
      this.i++;
    }
    //  this.flag = false; //禁止联想词刷新  TODO
    this.word = this.c[this.i]; //改变联想词为选中行
    (this.$refs.list as any)[this.i].style.background = "rgba(0, 0, 0, .08)"; //修改选中行样式
  }
  public lenovo(): void {
    if (this.word != "") {
      // @ts-ignore
      this.$jsonp(
        "https://sp0.baidu.com/5a1Fazu8AA54nxGko9WTAnF6hhy/su?wd=" +
          this.word +
          "&cb=",
        "callback"
      );
    } else {
      this.c = ""; //清空联想词
    }

    if (this.c != "") {
      (this.$refs.list as any)[this.i].style.background = "rgba(0, 0, 0, 0)"; //还原颜色
    }
    //重置方向键初始值s
    this.keyFlag = "-";
    this.i = 0;
  }
}
